import { render, staticRenderFns } from "./star-rating.vue?vue&type=template&id=fde73a0c&scoped=true&"
import script from "./star-rating.vue?vue&type=script&lang=js&"
export * from "./star-rating.vue?vue&type=script&lang=js&"
import style0 from "./star-rating.vue?vue&type=style&index=0&id=fde73a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde73a0c",
  null
  
)

export default component.exports